import React, { useState, useEffect, useCallback, useRef } from 'react';
import Icon from 'components/UI/Icon';
import SearchMenu from './SearchMenu';
import { useClickOutside } from 'utils/hooks';
import { useHistoryCallback } from 'utils/routing';
import { pushSearchEvent } from 'utils/analytics';
import { observer, searchStore as store } from 'store';

import * as styles from './DesktopSearch.module.scss';

function DesktopSearch() {
  const [isMenuVisible, setMenuVisible] = useState(false);
  const menuRef = useRef();

  const toggleMenu = useCallback(() => {
    setMenuVisible(prev => !prev);
    if (isMenuVisible) {
      pushSearchEvent({
        action: 'search_close',
        deviceType: 'Desktop',
        pageUrl: window.location.href,
      });
    } else {
      pushSearchEvent({
        action: 'search_open',
        deviceType: 'Desktop',
        pageUrl: window.location.href,
      });
    }
  }, [isMenuVisible]);

  const handleCloseMenu = useCallback(() => {
    setMenuVisible(false);
  }, []);

  const handleCloseMenuWithEvent = useCallback(() => {
    handleCloseMenu();
    if (isMenuVisible) {
      pushSearchEvent({
        action: 'search_close',
        deviceType: 'Desktop',
        pageUrl: window.location.href,
      });
    }
  }, [isMenuVisible, handleCloseMenu]);

  useClickOutside([menuRef], handleCloseMenuWithEvent);
  useHistoryCallback(handleCloseMenu);

  useEffect(() => {
    if (store.desktopMenuOpen) {
      setMenuVisible(false);
    }
  }, [store.desktopMenuOpen]);

  return (
    <div className={styles.desktopSearch} ref={menuRef}>
      <button aria-label="search" onClick={toggleMenu} className={styles.searchButton}>
        <Icon name="loupe-left-side" className={styles.searchIcon} />
      </button>
      <SearchMenu visible={isMenuVisible} handleCloseMenu={handleCloseMenu} />
    </div>
  );
}

export default observer(DesktopSearch);
